import React from 'react';
import PropTypes from 'prop-types';

import FusionCharts from 'fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ExcelExport from 'fusioncharts/fusioncharts.excelexport';
import ReactFC from 'react-fusioncharts';
import LoadingSpinner from 'components/LoadingSpinner';
import { Message } from 'components/shared';
import FCCharts from 'fusioncharts/fusioncharts.charts';

ReactFC.fcRoot(FusionCharts, FCCharts, FusionTheme, ExcelExport);

const FusionChart = ({ state, widgetType, dataSource, forwardRef }) => {
  const { isLoading, isError, error, data } = state;

  if (isError) {
    return <Message type="error" text={error} />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isLoading && !isError && !data) {
    return <Message type="error" text="No data available for this overlay" />;
  }

  return (
    <ReactFC
      type={widgetType}
      width="100%"
      height="220"
      dataFormat="JSON"
      dataSource={dataSource}
      ref={forwardRef}
    />
  );
};

FusionChart.propTypes = {
  widgetType: PropTypes.string,
  widgetState: PropTypes.shape({ id: PropTypes.string, isLegendDisplayed: PropTypes.bool }),
  dataSource: PropTypes.shape({}),
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.shape({})
  }).isRequired,
  forwardRef: PropTypes.shape({})
};
FusionChart.defaultProps = {
  widgetType: null,
  widgetState: {},
  dataSource: {},
  forwardRef: null,
  dynamicHeight: null
};

export default FusionChart;
